<div class="container" uploadDocumentDirective (fileDropped)="onFileDropped($event)">
	<input
		type="file"
		#fileDropRef
		id="fileDropRef"
		[multiple]="isMultipleFileUpload"
		(change)="fileBrowseHandler($event.target.files)"
		[accept]="filesTypesAllowed.join(',')"
		[disabled]="isOneFileOnly()"
	/>
	<i class="fas fa-cloud-upload doc-upload-ico"></i>
	<h5>Glissez et déposez le fichier ici ou <label for="fileDropRef"> Parcourir le fichier</label></h5>
</div>

<div class="table-responsive" [formGroup]="fileForm">
	<table class="table table-borderless letter-space" aria-describedby="listeDocuments">
		<thead>
			<tr>
				<th class="col-sortable" (click)="sortTable('name', isAsc)">{{ 'Documents.List.Columns.Name' | translate }}</th>
				<th class="col-sortable col-file-size" (click)="sortTable('size', isAsc)">
					{{ 'Documents.List.Columns.Weight' | translate }}
				</th>
				<th *ngIf="showTrashButton"></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of fileArrayControls; let i = index" class="table-row" formArrayName="fileArray">
				<td>{{ item?.get('file')?.value?.name }}</td>
				<td>{{ formatBytes(item?.get('file')?.value?.size) }}</td>
				<td *ngIf="showTrashButton" class="button-trash">
					<button type="button" (click)="removeFile(i)" class="btn btn-secondary btn-sm btn-trash">
						<i class="fas fa-trash"></i>
					</button>
				</td>
			</tr>
			<tr
				*ngIf="fileArrayControls?.length === 0"
				datagrid-row-empty
				translationKey="Documents.List.Columns.NoResultFound"
				[colspan]="9"
			></tr>
		</tbody>
	</table>
</div>
